import { Injectable } from '@angular/core';
import { ServiceAccessEnableToggleService } from './service-access-disabled/service-access-enable-toggle.service';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  constructor(private readonly serviceAccessEnableToggleService: ServiceAccessEnableToggleService) {}

  static createInstance(): AppInitService {
    return new AppInitService(new ServiceAccessEnableToggleService());
  }

  init() {
    try {
      return this.serviceAccessEnableToggleService.serviceAccessEnableCheck().toPromise();
    } catch {
      return Promise.resolve(true);
    }
  }
}